import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontFredoka, theme } from "@product/scmp-sdk";

import { Heading } from "scmp-app/components/posties/brochure-homepage/heading";
import { SCMPYoutubeVideoContainer } from "scmp-app/components/scmp-youtube-video/styles";

import Sand from "./sand.svg?url";

export const Container = styled.div`
  position: relative;

  scroll-margin-top: 66px;

  ${theme.breakpoints.up("desktop")} {
    scroll-margin-top: 100px;
  }
`;

export const HeaderContainer = styled.div`
  position: relative;

  margin-block-end: 48px;
  margin-inline: auto auto;
  padding-block-start: 40px;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    padding-block-start: 40px;
  }
  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 108px;
  }
`;

export const Header = styled(Heading)`
  max-inline-size: 220px;
  margin-block-end: 20px;
  margin-inline: auto;

  font-size: 36px;
  line-height: 40px;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: none;
    margin-block-end: 24px;
  }
  ${theme.breakpoints.up("desktop")} {
    font-size: 56px;
    line-height: 56px;
  }
`;

export const Description = styled.div`
  max-inline-size: 328px;
  margin: auto;

  font-size: 18px;
  font-family: ${fontFredoka};
  line-height: 24px;
  letter-spacing: -0.01em;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 504px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }

  span {
    display: inline-block;

    padding-inline: 10px;

    color: #ffffff;
    font-weight: 600;
    font-size: 24px;
    line-height: 33.6px;

    border-radius: 2px;

    background-color: #eb4d42;

    ${theme.breakpoints.up("desktop")} {
      font-size: 28px;
      line-height: 39.2px;
    }
  }
`;

export const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin-block-end: 40px;
  margin-inline: auto;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    gap: 24px;

    max-inline-size: 560px;
    margin-block-end: 40px;
  }

  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;

    max-inline-size: 806px;
    margin-block-end: 64px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 1181px;
    margin-block-end: 121px;
  }

  ${SCMPYoutubeVideoContainer} {
    display: block;
    flex: 1;

    border-radius: 8px;

    overflow: hidden;

    ${theme.breakpoints.up("tablet")} {
      border-radius: 15px;
    }
  }
`;

export const SandStyle = css`
  position: relative;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const StyledSand = styled.div`
  ${SandStyle}
  background-image: url(${Sand});

  aspect-ratio: 1500/118;
`;
